import { connect } from 'react-redux';
import { canAward, canFetchAwardedCreatives } from 'entries/utils';
import { getAwards } from 'entries/ducks';
import { getProject } from 'project/ducks/project';
import { fetchAwarded as fetchAwardedCreatives, getAwarded } from 'project/ducks/creatives';
import Awards from 'entries/components/awards';

const mapStateToProps = (state) => {
  const user = state.user.profile_data;
  const project = getProject(state);
  const awardedCreatives = getAwarded(state, true);

  return {
    awards: getAwards(state),
    canAward: canAward({ user, project, awardedCreatives }),
    canFetchAwarded: canFetchAwardedCreatives({ user, project }),
    project,
    awardedCreatives
  };
};

export default connect(mapStateToProps, {
  fetchAwardedCreatives
})(Awards);



// WEBPACK FOOTER //
// ./entries/containers/awards.js